// API client for the Pricing Strategy Analyzer.
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const BASE = `${API_URL}/seller-intelligence/pricing`;

const authHeaders = (token) => ({
  Authorization: `Bearer ${token}`,
  'Content-Type': 'application/json',
});

export class ReportUnavailableError extends Error {
  constructor(message) { super(message); this.reportUnavailable = true; }
}

export class NotConnectedError extends Error {
  constructor(message) { super(message); this.notConnected = true; }
}

const call = async (url, options = {}) => {
  const res = await fetch(url, options);
  const data = await res.json().catch(() => ({}));
  if (res.status === 409 && data.error === 'report_unavailable') {
    throw new ReportUnavailableError(data.message);
  }
  if (res.status === 400 && data.error === 'amazon_not_connected') {
    throw new NotConnectedError(data.message);
  }
  if (!res.ok) throw new Error(data.message || `Request failed (${res.status})`);
  return data;
};

// SF1 — every price change and deal, with what it did to margin.
export const getPriceImpact = (token, { sku } = {}) =>
  call(`${BASE}/impact${sku ? `?sku=${encodeURIComponent(sku)}` : ''}`, {
    headers: authHeaders(token),
  });

// SF2 — response as a range, never a point estimate.
export const getElasticity = (token) =>
  call(`${BASE}/elasticity`, { headers: authHeaders(token) });

// SF4 — a recommended price where the evidence supports one. Never applied.
export const getRecommendations = (token, { feesPerUnit } = {}) =>
  call(`${BASE}/recommendations${feesPerUnit ? `?fees_per_unit=${feesPerUnit}` : ''}`,
    { headers: authHeaders(token) });

// SF3 — the single source of Buy Box state.
export const getCompetitors = (token) =>
  call(`${BASE}/competitors`, { headers: authHeaders(token) });

// SF5 — category positioning.
export const getPositioning = (token) =>
  call(`${BASE}/positioning`, { headers: authHeaders(token) });
